module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-ceremony-producer-ae1738a05e178dee638b50ac857ebd88.png";